import React, { Component } from 'react';
import Calendar from 'react-calendar/dist/entry.nostyle';
import moment from 'moment-timezone';

const CALENDAR_ID = 'calendariomasberenguer@gmail.com';
const API_KEY = 'AIzaSyAEQKnD9Lb3w8tvZ2_xrWFikBaFLm3BUU4';

const cachedEvents = {};

const getSpanishDayMoment = date => {
  return moment.tz(moment(date).format('YYYY-MM-DD'), 'Europe/Madrid');
};

const hasEventOnDate = date => {
  const month = `${date.getFullYear()}-${date.getMonth() + 1}`;
  if (!cachedEvents[month]) {
    return false;
  }
  const events = cachedEvents[month];
  for (let i = 0; i < events.length; i++) {
    const event = events[i];
    const startDate = getSpanishDayMoment(
      new Date(event.start.date || event.start.dateTime)
    )
      .startOf('day')
      .toDate();
    // console.log('START: ' + startDate);
    const endDate = getSpanishDayMoment(
      new Date(event.end.date || event.end.dateTime)
    )
      .subtract(1, 'days')
      .endOf('day')
      .toDate();
    // console.log('END: ' + endDate);
    if (date >= startDate && date <= endDate) {
      // console.log('Date ' + date + ' is busy because of event: ');
      // console.log(event);
      return true;
    }
  }
  return false;
};

const getMonthEvents = date => {
  const month = `${date.getFullYear()}-${date.getMonth() + 1}`;
  if (cachedEvents[month]) {
    return Promise.resolve();
  }
  console.log('load events for: ' + month);
  const dateMin = getSpanishDayMoment(date)
    .startOf('month')
    .toDate();
  const dateMax = getSpanishDayMoment(date)
    .endOf('month')
    .toDate();
  const url = `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events?key=${API_KEY}&timeMin=${dateMin.toISOString()}&timeMax=${dateMax.toISOString()}`;
  // console.log(`url: ${url}`);
  return fetch(url)
    .then(data => {
      return data.json();
    })
    .then(data => {
      if (data.items) {
        const events = data.items;
        console.log(`loaded ${events.length} events for ${month}`);
        cachedEvents[month] = events;
      }
    });
};

export default class App extends Component {
  componentDidMount() {
    const activeStartDate = getSpanishDayMoment(new Date())
      .startOf('day')
      .toDate();
    this.didChange({ activeStartDate });
  }
  didChange = data => {
    const date = data.activeStartDate;
    const prevMonthDate = new Date(
      date.getFullYear(),
      date.getMonth() - 1,
      date.getDate()
    );
    const nextMonthDate = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate()
    );
    Promise.all([
      getMonthEvents(prevMonthDate),
      getMonthEvents(date),
      getMonthEvents(nextMonthDate)
    ]).then(() => {
      this.forceUpdate();
    });
  };
  render() {
    const tileClassFunc = ({ date }) => {
      date = getSpanishDayMoment(date)
        .startOf('day')
        .toDate();
      return hasEventOnDate(date) ? 'reserved' : null;
    };
    return (
      <Calendar
        onActiveStartDateChange={this.didChange}
        tileClassName={tileClassFunc}
      />
    );
  }
}
